import type { Test, TestParticipant } from '@/types'

/**
 * Участник, по которому показываем балл в списке тестов.
 * 1) Целевой ученик (`target_type === 'user'` и `target_id`), если есть в участниках.
 * 2) Участник просматривающего — только если у него уже посчитан балл (не затираем чужой балл «пустой» строкой учителя).
 * 3) Любой участник с непустым `results_score` (например, ученик при просмотре списка учителем без явной цели user в poly).
 * 4) Просматривающий или первый участник — чтобы не терять строку, если баллов ещё нет.
 */
export function pickParticipantForListScore(run: Test, viewerUserId: number): TestParticipant | null {
  const parts = run.participants ?? []
  if (parts.length === 0) return null

  const tid = run.target_type === 'user' && run.target_id != null ? run.target_id : null
  if (tid != null) {
    const byTarget = parts.find((p) => (p.user?.id ?? p.user_id) === tid)
    if (byTarget) return byTarget
  }

  const byViewer = parts.find((p) => (p.user?.id ?? p.user_id) === viewerUserId)
  if (byViewer != null && byViewer.results_score != null) {
    return byViewer
  }

  const withScore = parts.find((p) => p.results_score != null)
  if (withScore) return withScore

  return byViewer ?? parts[0] ?? null
}
